/** Normalises anything that was thrown (Error, Status number, string, ...) into an Error for telemetry. */
export const toError = (thrown: unknown): Error =>
  thrown instanceof Error ? thrown : new Error(String(thrown));
